import React from 'react';

function ServiceCard({ title, description, icon: Icon, onClick }) {
  return (
    <button type='button' className='home-service-card' onClick={onClick}>
      <div className='home-service-card__icon-wrap'>
        <Icon className='home-service-card__icon' />
      </div>
      <h3 className='home-service-card__title'>{title}</h3>
      <p className='home-service-card__description'>{description}</p>
    </button>
  );
}

export default ServiceCard;
